import StepperBlock, { StepperBlockProps } from './StepperBlock';

export type { StepperBlockProps };
export default StepperBlock;
